import {Breadcrumbs, Link, Stack, Typography} from "@mui/material";
import {Link as RouterLink, Navigate, useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import {appSession} from "../../../Broadtask";

const ChannelListenerViewer = () =>
{
    const navigate = useNavigate();
    const {networkUID, channelUID, listenerUID} = useParams();

    return <Stack spacing={1}>
        <Stack direction="row"
               sx={{ backgroundColor: '#1e1e1e'}}
               alignItems="center" justifyContent="space-between" padding={1}>
            <Breadcrumbs>
                <Link component={RouterLink} to={"/"} underline={"hover"}>Home</Link>
                <Link component={RouterLink} to={"/networks"} underline={"hover"}>Networks</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID} underline={"hover"}>{networkUID}</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID + "/channels"} underline={"hover"}>Channels</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID + "/channels/" + channelUID} underline={"hover"}>{channelUID}</Link>
                <Link component={RouterLink} to={"/networks/" + networkUID + "/channels/" + channelUID} underline={"hover"}>Channel Listeners</Link>
                <Typography>{listenerUID}</Typography>
            </Breadcrumbs>
        </Stack>

        {
            appSession.activeSession() === false ?
            <Navigate to="/login"/> :
            <Stack direction="column" justifyContent="flex-start" alignItems="stretch"
                   spacing={2} padding={0}>

                {/* Create Channel */}
                <Stack direction="column" spacing={1} padding={1} width="100%"
                       alignItems="flex-start" justifyContent="flex-start"
                       sx={{ backgroundColor: '#0a0a0a', borderRadius: 2}}>
                    <Stack direction="row" width="100%"
                           justifyContent="space-between"
                           padding={1} spacing={1}>
                        <Typography variant="h6">Channel Listener</Typography>
                    </Stack>
                    <Stack direction="column" spacing={1} width="100%" minHeight={100}
                           sx={{ backgroundColor: '#1e1e1e'}}>

                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" paddingTop={1}>

                    </Stack>
                </Stack>

            </Stack>
        }

    </Stack>
};

export default ChannelListenerViewer;
